import { useEffect, useState } from "react";
import { Form, Button, Modal, Spinner, Toast, ToastContainer, ProgressBar } from "react-bootstrap";
import CloseButton from 'react-bootstrap/CloseButton';

import { Rating } from "@mui/material";
import StarIcon from '@mui/icons-material/Star';

import { QUESTION_TYPE } from "../../../shared/utils/constants";
import { AppLoader } from "../../../shared/components/Loader";
import OtpHoc from "./OTPHOC";
import { Countdown } from "../../../shared/components/Countdown";
import { Calculator } from "../../../shared/components/Calculator";
import CodeViewer from "../../../shared/components/CodeViewer";
import { MediaAttachment, RenderQuestion } from "./QuestionRenderer";

import { ACCESS_TOKEN } from "../../../shared/settings/auth";
import { deleteApi, getApi, postApi, putApi } from "../../../shared/services/apiHelper";
import { takeAssessmentActivity, takeAssessmentRunAnswerAdd, takeAssessmentRunDeleteAsset, takeAssessmentRunDetail, takeAssessmentRunDetailToken, takeAssessmentRunGenerateOTP, takeAssessmentRunUpdate } from "../../../shared/settings/apiConfig";
import { setValue } from "../../../shared/settings/token";

import './TakeAssessment.scss';

export const TakeAssessment = (props) => {

    const [isLoading, setIsLoading] = useState(false);
    const [showReviewScreen, setShowReviewScreen] = useState(false);
    const [edit, setEdit] = useState(false);

    const [assessmentData, setAssessmentData] = useState({});
    const [sectionIndex, setSectionIndex] = useState(null);
    const [questionIndex, setQuestionIndex] = useState(null);
    const [questionData, setQuestionData] = useState({});
    const [currentAnswerData, setCurrentAnswerData] = useState({ answer: null, previousAnswer: null, language: null })
    const [Otp, setOtp] = useState("")
    const [image, setimage] = useState({})

    const [constModal, setConstModal] = useState({});
    const [allowAttachmentData, setAllowAttachmentData] = useState([]);
    const [nextLoading, setNextLoading] = useState(false);
    const [uploadLoading, setUploadLoading] = useState(false);
    const [message, setMessage] = useState({ type: '', message: '' });
    const [toast, showToast] = useState({ show: false, type: '', message: '' });
    const [geoLocation, setGeoLocation] = useState({ latitude: null, longitude: null });

    // function showError(error) {
    //     switch (error.code) {
    //         case error.PERMISSION_DENIED:
    //             setGeoLocation({
    //                 ...geoLocation,
    //                 error: " Please enable location in browser settings"
    //             })
    //             break;
    //         case error.POSITION_UNAVAILABLE:
    //             setGeoLocation({
    //                 ...geoLocation,
    //                 error: "Location information is unavailable."
    //             })
    //             break;
    //         case error.TIMEOUT:
    //             setGeoLocation({
    //                 ...geoLocation,
    //                 error: "The request to get  location timed out."
    //             })
    //             break;
    //         case error.UNKNOWN_ERROR:
    //             setGeoLocation({
    //                 ...geoLocation,
    //                 error: "An unknown error occurred."
    //             })
    //             break;
    //     }
    // };

    const responseHandle = (response) => {
        setIsLoading(false);
        setAssessmentData(response.data.data);
        setSectionIndex(0);
        setQuestionIndex(0);
        if (response.data.data.runstatus === 'In Progress') {
            getGeoLocation().catch(() => { });
        }
    };

    useEffect(() => {
        // TODO check if we need to log the reload activity.
        setIsLoading(true);
        if ("token" in props.match.params) {
            postApi(takeAssessmentRunDetailToken, { data: { token: props.match.params?.token } }).then((response) => {

                if (response?.data?.status == "success") {
                    setValue(ACCESS_TOKEN, response.data.data?.tempauthtoken)
                    responseHandle(response)
                } else {
                    showToast({ message: response?.data?.message, type: response?.data?.message?.includes("completed") ? "success" : "danger", show: true })
                }
            }).catch(error => {
                showToast({ message: error?.response?.data?.message, type: error?.response?.data?.message?.includes("completed") ? "success" : "danger", show: true })
                setIsLoading(false)
                    ;
            });
        } else {
            getApi(takeAssessmentRunDetail + props.match.params.runAssessmentClientId).then(async (response) => {
                if (response?.data?.status == "success") {
                    responseHandle(response)
                } else {
                    showToast({ message: response?.data?.message, type: response?.data?.message?.includes("completed") ? "success" : "danger", show: true })
                }
            }).catch(error => {
                showToast({ message: error?.response?.data?.message, type: error?.response?.data?.message?.includes("completed") ? "success" : "danger", show: true })
                setIsLoading(false)
                    ;
            });
        }

        // window.addEventListener("visibilitychange", handleVisibilityChange);
        // window.addEventListener('blur', handleVisibilityChange);

        return () => {
            // window.removeEventListener("visibilitychange", handleVisibilityChange);
            // window.removeEventListener('blur', handleVisibilityChange);

            // TODO check if we need to log the exit activity.
        };
    }, []);

    useEffect(() => {
        if (sectionIndex != null && questionIndex != null && assessmentData?.sections?.[sectionIndex]?.questions?.[questionIndex]) {
            let question = assessmentData.sections[sectionIndex].questions[questionIndex];
            setQuestionData(question);
        }
    }, [sectionIndex, questionIndex]);

    // const handleVisibilityChange = (event) => {
        // if (window.visibilityState === "visible") {
        //     activityApi('tabchange');
        // }
        // alert("changed");
        // console.log("moved away");
    // };

    const getGeoLocation = () => {
        return new Promise((resolve, reject) => {
            // const location = window.navigator && window.navigator.geolocation;
            // location.getCurrentPosition((position) => {
            //     setGeoLocation({latitude: position.coords.latitude, longitude: position.coords.longitude});
            //     resolve(position);
            // }, (error) => {
            //     openModal('Location', false, 'sm');
            //     reject(error);
            // },
            // { enableHighAccuracy:true });
            resolve();
        });
    };

    const addAnswerAPI = async (answer, programLanguage) => {
        let question = { ...assessmentData.sections[sectionIndex].questions[questionIndex] };
        let payload = {
            "runid": assessmentData.runid,
            "runassessmentid": assessmentData.runassessmentid,
            "runassessmentclientid": assessmentData.runassessmentclientid,
            "questionid": question.id
        };

        if (Array.isArray(allowAttachmentData) && allowAttachmentData.length > 0) {
            payload["assets"] = [{
                "name": allowAttachmentData[0]['name'],
                "type": allowAttachmentData[0]['type'],
                "url": allowAttachmentData[0]['serverurl']
            }];
            question["uploadedassets"] = [...question["uploadedassets"], ...allowAttachmentData];
        }

        if (question['questiontype'] == QUESTION_TYPE.DESCRIPTIVE) {
            payload['singleinputanswer'] = answer;
            question["singleinputanswer"] = answer;
        } else if (question['questiontype'] == QUESTION_TYPE.CODING) {
            payload['singleinputanswer'] = answer;
            payload['programminglanguageopted'] = programLanguage;
            question["singleinputanswer"] = answer;
            question['programminglanguageopted'] = programLanguage;
        } else if (question['questiontype'] == QUESTION_TYPE.RATING) {
            if (answer) {
                payload['ratinganswer'] = answer;
                question["ratinganswer"] = answer;
            } else {
                return;
            }
        } else if (question['questiontype'] == QUESTION_TYPE.TRUEORFALSE) {
            if (answer.length > 0) {
                payload['optionid'] = answer[0];
                question.options.map(elem => {
                    elem.answered = answer.includes(elem.id) ? 1 : 0;
                });
            } else {
                return;
            }
        } else if (question['questiontype'] == QUESTION_TYPE.MULTICHOICE) {
            payload['optionid'] = answer;
            question.options.map(elem => {
                elem.answered = answer.includes(elem.id) ? 1 : 0;
            });
        } else if ( question['questiontype'] != QUESTION_TYPE.GRAPHICAL_SUBMISSION ) {
            return;
        }
        await postApi(takeAssessmentRunAnswerAdd, { data: payload }).then((response) => {
            let questions = [...assessmentData.sections[sectionIndex].questions];
            questions[questionIndex] = question;

            if (typeof response.data.data === 'object') {
                if ('removequestions' in response.data.data && Array.isArray(response.data.data.removequestions) && response.data.data.removequestions.length > 0) {
                    response.data.data['removequestions'].forEach((elem) => {
                        let index = questions.findIndex((item) => { return item.id == elem; });
                        if (index > -1) {
                            questions.splice(index, 1);
                        }
                    });
                }
                if ('addquestions' in response.data.data && Array.isArray(response.data.data.addquestions) && response.data.data.addquestions.length > 0) {
                    response.data.data['addquestions'].forEach((elem) => {
                        let index = questions.findIndex((item) => { return item.id == elem.id; });
                        if (index < 0) {
                            questions.push(elem);
                        }
                    });
                }
            }

            setAssessmentData(prevState => {
                prevState.sections[sectionIndex].questions = questions;
                return { ...prevState };
            });
        }).catch(error => {
            console.log(error);
        });
    }

    const activityApi = (key) => {
        const payload = {
            runassessmentclientid: assessmentData.runassessmentclientid,
            activitytype: key.toLowerCase(),
            latitude: geoLocation.latitude,
            longitude: geoLocation.longitude
        }
        postApi(takeAssessmentActivity, { data: payload }).catch((e) => { console.log(e) });
    }

    const onAction = async (key, answer, previousAnswer, programLanguage=null) => {
        let sectionIdx = null, questionIdx = null, nextQuestionId = null;
        if(key == "cancel") {
            setShowReviewScreen(true);
            setEdit(false);
            return
        }
        if (key != "Previous") {

            if ((questionIndex + 1) < assessmentData.sections[sectionIndex].questions.length) {
                questionIdx = questionIndex + 1;
            } else if ((sectionIndex + 1) < assessmentData.sections.length) {
                sectionIdx = sectionIndex + 1;
                questionIdx = 0;
            } else {
                setShowReviewScreen(true);
                setEdit(false);
            }

            if (questionIdx != null) {
                nextQuestionId = assessmentData?.sections[sectionIdx ?? sectionIndex]?.questions[questionIdx]?.id;
            }

            // TODO when skipped we need to call a api for saving.
            if (key != "Skip") {

                // TODO when changing the program language we need to call the api again.
                if (JSON.stringify(answer) != JSON.stringify(previousAnswer) || allowAttachmentData.length > 0) {
                    setNextLoading(true);

                    await addAnswerAPI(answer, programLanguage);

                    setNextLoading(false);
                }

                if (key == 'Submit') {
                    setShowReviewScreen(true);
                    setEdit(false);
                }
            }

            setAllowAttachmentData([]);

        } else if (key == "Previous") {

            if (questionIndex > 0) {
                questionIdx = questionIndex - 1;
            } else if (sectionIndex > 0 && assessmentData.sections[sectionIndex - 1]?.questions.length > 0) {
                sectionIdx = sectionIndex - 1;
                questionIdx = assessmentData.sections[sectionIndex - 1].questions.length - 1;
            }
        }

        if (sectionIdx != null) {
            setSectionIndex(sectionIdx);
        }

        if (questionIdx != null) {
            setQuestionIndex(questionIdx);
        }

        activityApi(key);

    };

    const checkNextDisable = () => {
        if ( uploadLoading ) {
            return true;
        } else if ( questionData.questiontype == QUESTION_TYPE.GRAPHICAL_SUBMISSION ) {
            return questionData?.uploadedassets?.length == 0 && allowAttachmentData.length == 0;
        } else if ( currentAnswerData.answer == null ? true : typeof currentAnswerData.answer == "string" ? currentAnswerData.answer.replace(/<p>/g, '').replace(/<br[\/]?>/g, '').replace(/<[\/]?p>/g, '').trim() == "" : currentAnswerData.answer.length == 0 ) {
            return true;
        }

        return false;
    };

    const renderReviewScreenAnswer = (question) => {
        let answer = [];
        if (question.questiontype == QUESTION_TYPE.MULTICHOICE || question.questiontype == QUESTION_TYPE.TRUEORFALSE) {
            question.options.map((item) => {
                if (item.answered) {
                    answer.push(item.id);
                }
            });
        } else if (question.questiontype == QUESTION_TYPE.DESCRIPTIVE) {
            answer = question.singleinputanswer;
        } else if (question.questiontype == QUESTION_TYPE.RATING) {
            answer = question.ratinganswer;
        } else if (question.questiontype == QUESTION_TYPE.REORDER) {
            answer = question.options;
        }

        switch (question.questiontype) {
            case QUESTION_TYPE.DESCRIPTIVE:
                return (
                    <div className="px-4 px-sm-5" style={{ padding: "1rem 1.2rem" }} dangerouslySetInnerHTML={{ __html: answer }}></div>
                )
            case QUESTION_TYPE.MULTICHOICE:
                return (
                    <Form className="px-4 px-sm-5">
                        {
                            question.options.map((item, index) => (
                                <div key={`multicheck-review-${item.id}-${index}`} className="d-flex justify-content-between my-1">
                                    <label className="label">{String.fromCharCode(97 + index)}{") "} {item.optionname}</label>
                                    <Form.Check key={`multicheck-review-${item.id}-${index}`} disabled={true} type="checkbox" value={item.id} defaultChecked={answer.includes(item.id)} />
                                </div>
                            ))
                        }
                    </Form>
                )
            case QUESTION_TYPE.TRUEORFALSE:
                return (
                    <Form className="px-4 px-sm-5">
                        {
                            question.options.map((item, index) => (
                                <div key={`radio-review-${item.id}-${index}`} className="d-flex justify-content-between my-1">
                                    <label className="label">{item.optionname}</label>

                                    <Form.Check key={`radio-review-${item.id}-${index}`} disabled={true} type="radio" value={item.id} defaultChecked={answer.includes(item.id)} />
                                </div>
                            ))
                        }
                    </Form>
                )
            case QUESTION_TYPE.RATING:
                return (
                    <div className="d-flex flex-wrap gap-3" style={{ padding: "1rem 1.2rem" }}>
                        <Rating name="size-large" value={answer ? answer : 0} size="large" precision={0.5} readOnly
                            icon={<StarIcon fontSize="large" />}
                            emptyIcon={<StarIcon fontSize="large" />} />
                    </div>
                )
            case QUESTION_TYPE.REORDER:
                return (
                    <div>
                        {
                            answer.map((item, index) => (
                                <div key={`reorder-review-${item.id}-${index}`} className="d-flex justify-content-between p-2 border">
                                    <label>{item.optionname}</label>
                                </div>
                            ))
                        }
                    </div>
                )
            case QUESTION_TYPE.CODING:
                return (
                    <CodeViewer code={question.singleinputanswer} language={question.programminglanguageopted?.toLowerCase()} />
                )
            default:
                break;
        }
    };

    const openModal = (type, showHeader = true, modalSize = 'lg') => {
        setConstModal(prevState => {
            prevState.show = true;
            prevState.type = type;
            prevState.showHeader = showHeader;
            prevState.modalSize = modalSize;

            return { ...prevState };
        });
    };

    const closeModal = () => {
        setConstModal(prevState => {
            prevState.show = false;
            prevState.type = "";

            return { ...prevState };
        });
    };

    const startAssessment = () => {
        getGeoLocation().then(() => {
            if ( assessmentData.responderid ) {
                verifyOtp();
            } else {
                generateOTP();
            }
        }).catch(() => { });
    };

    const submitAssessment = (navigate = true) => {
        let payload = {
            runid: assessmentData.runid,
            runassessmentid: assessmentData.runassessmentid,
            runassessmentclientid: assessmentData.runassessmentclientid,
        };
        putApi(takeAssessmentRunUpdate, { data: payload }).then(response => {
            if (("token" in props.match.params)) {
                setAssessmentData({})
                showToast({
                    message: `Thank you for completing your online assessment. Your responses have been successfully submitted.
                If you have any questions or need further assistance, please contact the department`, type: "success", show: true
                })
            } else {
                if (navigate) {
                    props.history.goBack();
                } else {
                    openModal('Autocomplete', false, 'sm');
                }
            }
        }).catch(error => {
            setAssessmentData({})
            showToast({ message: error?.response?.data?.message, type: error?.response?.data?.message?.includes("completed") ? "success" : "danger", show: true })
        });
    };

    const renderImageView = (question) => {
        return (
            <div className="d-flex align-items-center gap-3">
                {
                    Array.isArray(question.uploadedassets) && question.uploadedassets.map(asset =>
                        <>
                            {
                                asset.type?.startsWith("image") ?
                                    <div>
                                        <img style={{ width: '8rem' }} src={asset.url} />
                                    </div> :
                                    asset.type?.startsWith("video") ?
                                        <div className="h-50">
                                            <video controls style={{ width: "100%", height: "250px" }}>
                                                <source src={asset.url} type={asset.type} />
                                            </video>
                                        </div> :
                                        asset.type == "application/pdf" ?
                                            <div>
                                                <a href={asset.url} target="_blank" rel="noopener noreferrer">
                                                    <img className="w-100" src={`${process.env.PUBLIC_URL}/static/images/pdf-icon.png`} />
                                                </a>
                                            </div> : ''
                            }
                        </>
                    )
                }
            </div>
        )
    };

    const generateOTP = () => {
        if (assessmentData.runstatus == 'Not Started') {
            let payload = {
                runassessmentclientid: assessmentData.runassessmentclientid
            };
            putApi(takeAssessmentRunGenerateOTP, { data: payload }).then(response => {
                if (response?.data?.status == "success") {
                    setAssessmentData((prevState) => {
                        return ({ ...prevState, otpview: true })
                    })
                }
            }).catch(error => {
                console.log(error);
            });
        }

    }
    const verifyOtp = () => {
        if (assessmentData.runstatus == 'Not Started') {
            if (Otp.length == 6 || assessmentData.responderid) {
                let payload = {
                    id: assessmentData.id,
                    runid: assessmentData.runid,
                    runassessmentid: assessmentData.runassessmentid,
                    runassessmentclientid: assessmentData.runassessmentclientid,
                    otp: Otp
                };
                putApi(takeAssessmentRunUpdate, { data: payload }).then(response => {
                    if (response?.data?.status == "success") {
                        setOtp("")
                        setAssessmentData((prevState) => {
                            return ({ ...prevState, runstatus: "In Progress", otperror: "" })
                        })
                    } else {
                        setAssessmentData((prevState) => {
                            return ({ ...prevState, otperror: response.data.message })
                        })
                    }
                }).catch(error => {
                    setAssessmentData((prevState) => {
                        return ({ ...prevState, otperror: error.response.data.message ? error.response.data.message : error.message })
                    })
                });
            }
        }

    }

    const deleteAnswerAsset = (asset, index, isUploaded = false) => {
        const payload = { runassessmentclientid: assessmentData.runassessmentclientid, questionid: questionData.id };
        if (asset.id) {
            payload.url = asset.url;
        } else {
            payload.url = asset.serverurl;
        }

        deleteApi(takeAssessmentRunDeleteAsset, { data: payload }).then(response => {
            if (isUploaded) {
                setQuestionData(prevState => {
                    prevState.uploadedassets.splice(index, 1);
                    return { ...prevState };
                });
            } else {
                setAllowAttachmentData([]);
            }
        }).catch((error) => {

        });
    }

    const countdownCallback = (options) => {
        if (!toast.show && options.timeRunningOut) {
            showToast(prevState => {
                prevState.show = true;
                prevState.type = "warning";
                prevState.message = `Your Assessment would auto submit in ${options.minutes} minute(s) ${options.seconds > 0 ? `and ${options.seconds} second(s)` : ''}`;
                return { ...prevState };
            });

            setTimeout(() => {
                showToast(prevState => {
                    prevState.show = false;
                    prevState.type = "";
                    prevState.message = "";
                    return { ...prevState };
                });
            }, 3000);
        } else if (options.timeOver) {
            submitAssessment(false);
        }
    };

    if (!(Object.keys(assessmentData).length > 0)) {
        return (
            <div className="h-100 w-100 d-flex align-items-center justify-content-center flex-column text-center px-5">
                <div className=" d-flex gap-1 align-items-center">
                    <div className={`text-${toast.type} text-3l`}>{toast.message}</div>
                </div>
            </div>
        )
    }

    const currentQuestionNumber = assessmentData?.sections.slice(0, sectionIndex).reduce((t, e) => t + (e?.questions?.length || 0), 0) + (questionIndex + 1);

    // Total questions in the assessment
    const totalQuestions = assessmentData?.sections.reduce((t, e) => t + (e?.questions?.length || 0), 0);

    // Calculate percentage
    const percentage = Math.round(((currentQuestionNumber - 1) / totalQuestions) * 100);

    return (
        <div className="take-assessment-container main-content">
            {
                isLoading || !assessmentData ? 
                <AppLoader /> : 
                (
                    <div className="position-relative">
                        {/** Take Assessment Header */}
                        {
                            !("token" in props.match.params) && 
                            <div className='d-flex gap-1 align-items-center'>
                                <img style={{ width: "2rem" }} 
                                    src={`${process.env.PUBLIC_URL}/static/images/back.png`} alt={"back"} 
                                    onClick={() => { 
                                        if(edit) {
                                            setShowReviewScreen(true);
                                            setEdit(false);
                                        } else {
                                            props.history.goBack(); 
                                        }
                                    }} 
                                />
                                <div className='screen-sub-head'>Assessment</div>
                            </div>
                        }

                        {/** Information Section */}
                        <div className="d-flex flex-column flex-sm-row justify-content-sm-end gap-3">
                            <div className="d-flex gap-2">
                                <div className="font-weight-bold">Subject/Topic:</div>
                                <div>{assessmentData.subjectname ? assessmentData.subjectname : '- - -'}</div>
                            </div>
                            <div className="d-flex gap-2">
                                <div className="font-weight-bold">Duration:</div>
                                <div>{assessmentData.duration} Mins</div>
                            </div>
                            <div className="d-flex gap-2">
                                <div className="font-weight-bold">Grading:</div>
                                <div>Score</div>
                            </div>
                        </div>

                        {/** Assessment name and decription */}
                        <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-md-between gap-3">
                            <div className="py-3" style={{flex: "1 1 70%"}}>
                                {image?.url && <img style={{ width: '10rem' }} src={image?.url} alt={"assessment Image"} />}
                                <div className="assess-title">{assessmentData.assessmentname}</div>
                                <div className="assess-description">{assessmentData.subtitle}</div>
                            </div>
                            <div className="d-flex align-items-center gap-2" style={{flex: "1 1 30%"}}>
                                <ProgressBar now={percentage} variant="success" style={{ height: "10px" }} />
                                <span style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                                    {percentage}%
                                </span>
                            </div>
                        </div>

                        <hr></hr>

                        {
                            assessmentData?.runstatus == "Not Started" ?
                                assessmentData?.otpview ?
                                <div className="d-flex align-items-center justify-content-center flex-column">
                                    <div className="d-flex align-items-center justify-content-center flex-column  py-5">
                                        <div>
                                            <div className="my-2" >Please enter OTP</div>
                                            <OtpHoc length={6} onChange={(otp) => {
                                                setAssessmentData((prevState) => {
                                                    return ({ ...prevState, otperror: "" })
                                                })
                                                setOtp(otp)
                                            }} resendOtp={() => { generateOTP() }} />
                                        </div>
                                        <div className="d-flex justify-content-center flex-column align-items-center ">
                                            <div className="text-info mb-1">{"Verification OTP is sent to the registered Email address "}</div>
                                            {assessmentData?.otperror && <div className="text-danger ">{assessmentData?.otperror}</div>}
                                        </div>
                                        <Button disabled={(Otp.length != 6)} onClick={verifyOtp} style={{ marginTop: "20px" }}>
                                            Verify OTP
                                        </Button>
                                    </div>
                                </div> :
                                <div className="d-flex flex-column gap-5">
                                    <div className="" >
                                        {/** Assessment Instruction */}
                                        <div className="my-2 mx-2 font-weight-bold">Instructions</div>
                                        <div className="my-2 mx-2 instruction">
                                            {assessmentData?.settings?.instruction ?
                                                <div className="" dangerouslySetInnerHTML={{ __html: assessmentData?.settings?.instruction }}></div> :
                                                <div>There are no specific/special instructions available for this assessment</div>
                                            }
                                        </div>
                                    </div>
                                    <div className=" d-flex justify-content-center alignItem-center">
                                        <Button className="bg-info" onClick={startAssessment}>Start</Button>
                                    </div>
                                </div> 
                            :
                            <>
                                {
                                    showReviewScreen ?
                                    <div className="question-renderer p-3 p-sm-4">
                                        {/** Question information, calculator and attachements */}
                                        <div className="d-flex my-2 align-items-center justify-content-between">
                                            <div className="font-weight-bold">Review Answers</div>
                                        </div>
                                        <div className="d-flex flex-column gap-4 question-container">

                                            {
                                                Array.isArray(assessmentData.sections) && assessmentData.sections.length > 0 && assessmentData.sections.map((section, sindex) => (
                                                    <div key={"review-screen-section" + section.id} className="d-flex flex-column gap-3">
                                                        <div className="d-flex justify-content-center font-weight-bold">{section.sectionname} </div>
                                                        {
                                                            section.questions.map((question, qindex) => (
                                                                <div key={"review-screen-question" + question.id}>
                                                                    <div className="d-flex gap-2">
                                                                        <div>{qindex + 1}.</div>
                                                                        <div className="question-content" dangerouslySetInnerHTML={{ __html: question.questionname }}></div>
                                                                    </div>

                                                                    <div className="d-flex align-items-center justify-content-between w-100 gap-3">
                                                                        <div className={`d-flex flex-column flex-grow-1 ${question.questiontype === QUESTION_TYPE.CODING ? 'overflow-hidden' : ''}`}>
                                                                            {renderReviewScreenAnswer(question)}
                                                                            {renderImageView(question)}
                                                                        </div>
                                                                        <div role="button" 
                                                                            onClick={() => {
                                                                                setSectionIndex(sindex);
                                                                                setQuestionIndex(qindex);
                                                                                setEdit(true);
                                                                                setShowReviewScreen(false);
                                                                            }}>
                                                                            <img  style={{ width: "1rem" }} src={`${process.env.PUBLIC_URL}/static/images/edit.png`} alt={"edit"} />
                                                                        </div>
                                                                    </div>
                                                                    {qindex == section.questions.length - 1 ? '' : <hr></hr>}
                                                                </div>
                                                              
                                                            ))
                                                        }
                                                    </div>
                                                ))
                                            }
                                            <div className="d-flex justify-content-end">
                                                <Button className="action-btn btn btn-primary" onClick={submitAssessment}>Submit</Button>
                                            </div>
                                        </div>
                                    </div> :
                                    <div className="d-flex flex-column gap-4">
                                        <div className="d-flex flex-column gap-4">
                                            {
                                                !assessmentData.responderid ? 
                                                <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-sm-between gap-2">
                                                    <div className="text-s">* Assessment will auto end on time out. </div>
                                                    <div className="d-flex gap-2 align-items-center justify-content-center">
                                                        <img style={{ width: "1.875rem" }} src={`${process.env.PUBLIC_URL}/static/images/clock.png`} alt={"clock"} />
                                                        {/* <Countdown startTime={assessmentData.starttime} targetAsMinutes={assessmentData.duration || 15} countdownCallback={countdownCallback} /> */}
                                                        <div className="font-weight-bold">Remaining</div> 
                                                    </div>
                                                </div> : ''
                                            }
                                            
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div>
                                                    <div className="header">{assessmentData?.sections?.[sectionIndex]?.sectionname}</div>
                                                    <div className="assess-description">{assessmentData?.sections?.[sectionIndex]?.sectionsummary}</div>
                                                </div>
                                                <div className="d-flex align-items-center gap-3">
                                                    <MediaAttachment 
                                                        question={assessmentData?.sections?.[sectionIndex]?.questions?.[questionIndex]} 
                                                        attachment={allowAttachmentData}
                                                        attachmentCallback={(data, uploading) => {
                                                            setUploadLoading(uploading);
                                                            setAllowAttachmentData(data);
                                                        }}
                                                    />
                                                    <div className="d-flex flex-column align-items-center gap-1">
                                                        <img style={{ width: "2rem" }} role={"button"} src={`${process.env.PUBLIC_URL}/static/images/calculator.png`} onClick={() => { openModal("Calculator"); }} />
                                                        <div className="img-text">Calculator</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* 
                                            <FocusOutDetector 
                                                focusOutOnChange={(count) => {
                                                    showToast({ show: true, message: `You have focused out from the window for ${count} time(s). The assessment will be auto submitted after 5 counts`, type: 'warning' });
                                                    setTimeout(() => {
                                                        showToast({ show: false, message: '', type: '' });
                                                    }, 3000);
                                                }}
                                            /> 
                                        */}
                                        <RenderQuestion 
                                            key={questionData.id}
                                            question={questionData}
                                            questionIndex={questionIndex}
                                            attachments={allowAttachmentData}
                                            value={currentAnswerData}
                                            onChange={(data) => {
                                                setCurrentAnswerData({...data});
                                            }}
                                            deleteAssetCallback={(asset, index, isUploaded) => {
                                                deleteAnswerAsset(asset, index, isUploaded);
                                            }}
                                        />

                                        {
                                            edit ?
                                            <div className="d-flex flex-column flex-sm-row justify-content-sm-between gap-3">
                                                <Button className="action-btn btn-secondary" onClick={() => { onAction("cancel", currentAnswerData.answer, currentAnswerData.previousAnswer) }}>Back</Button>
                                                <Button className="action-btn btn-primary" onClick={() => { onAction("Submit", currentAnswerData.answer, currentAnswerData.previousAnswer) }}>Submit</Button>
                                            </div> :
                                            <div className="d-flex flex-column flex-sm-row justify-content-sm-between gap-3">
                                                <Button disabled={sectionIndex <= 0 && questionIndex <= 0} className="action-btn" onClick={() => { onAction("Previous", currentAnswerData.answer); }}>Previous</Button>
                                                <div className="d-flex flex-column flex-sm-row justify-content-between gap-3">
                                                    <Button className={`action-btn btn-primary`} disabled={checkNextDisable()} onClick={() => { onAction("Next", currentAnswerData.answer, currentAnswerData.previousAnswer, currentAnswerData.language); }}>
                                                        Next {nextLoading ? <Spinner className='ms-2' as="span" animation="border" role="status" aria-hidden="true" /> : ''}
                                                    </Button>
                                                    {
                                                        !questionData.mandatory ? 
                                                        <Button className="action-btn btn-secondary text-white" disabled={uploadLoading || nextLoading} onClick={() => { onAction("Skip"); }}>Skip</Button> : ""
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                            </>
                        }

                        <Modal centered show={constModal.show} size={constModal.modalSize} animation={true}>
                            {
                                constModal.showHeader ?
                                    <Modal.Header className="modal-header">
                                        <div>{constModal?.type}</div>
                                        <CloseButton onClick={closeModal} />
                                    </Modal.Header> : null
                            }
                            <Modal.Body>
                                {
                                    constModal?.type == "Calculator" &&
                                    <div>
                                        <Calculator/>
                                    </div>
                                }
                                {
                                    constModal?.type == "Location" &&
                                    <div className="d-flex flex-column align-items-center gap-3">

                                        <div className="d-flex gap-1 align-items-center justify-content-center">
                                            <img src={`${process.env.PUBLIC_URL}/static/images/location-disable.svg`} />
                                            <div className="font-weight-bold">Location Disabled</div>
                                        </div>

                                        <div className="text-center">
                                            Please enable location services to continue your assessment.
                                        </div>

                                        <Button onClick={closeModal}>OK</Button>
                                    </div>
                                }
                                {
                                    constModal?.type == "Autocomplete" &&
                                    <div className="d-flex flex-column align-items-center gap-3">

                                        <div className="d-flex gap-1 align-items-center justify-content-center">
                                            <img style={{ width: '1.875rem' }} src={`${process.env.PUBLIC_URL}/static/images/clock.png`} />
                                            <div className="font-weight-bold">Time's up</div>
                                        </div>

                                        <div className="text-center">
                                            Time's up. Your assessment is auto submitted.
                                        </div>

                                        <Button onClick={() => { closeModal(); props.history.goBack(); }}>OK</Button>
                                    </div>
                                }
                            </Modal.Body>
                        </Modal>

                        <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1 }} >
                            <Toast show={toast.show} bg={toast.type} autohide={true} delay={2000}>
                                <Toast.Body>
                                    {toast.message}
                                </Toast.Body>
                            </Toast>
                        </ToastContainer>
                    </div>
                )
            }
        </div>
    );
};
